import { render, staticRenderFns } from "./DonutChart20.vue?vue&type=template&id=42be1200&scoped=true&"
import script from "./DonutChart20.vue?vue&type=script&lang=js&"
export * from "./DonutChart20.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42be1200",
  null
  
)

export default component.exports